import type { HotpadsListing } from 'app/client/analytics/types';
import { trackPropertyInfoCsEvent } from 'app/client/analytics';
import { getEnvelope, getPropertyInfo } from 'app/client/analytics/utils';

// TODO: Eventually remove these comments
// Comment explains where this trigger location is currently being called from for debugging purposes.
type PropertyCardTriggerLocation =
  | 'accepts_application_collection' // ListingCollection
  | 'affordable_apartments_collection' // ListingCollection
  | 'building_unit_card' // BuildingHdp
  | 'luxury_apartments_collection' // ListingCollection
  | 'popular_apartments_collection' // ListingCollection
  | 'portfolio_listings_module' // PortfolioProperties
  | 'promo_apartments_collection' // ListingCollection
  | 'recent_search_collection' // ListingCollection
  | 'recently_viewed_listings_module' // RecentlyViewed
  | 'recommended_search_collection' //CollectionResultsPage/RecommendedApartments
  | 'saved_search_collection' // ListingCollection
  | 'search_results_list' // MobileSRP/ListingCards / AreaListingsContainer <-- listings containers on mWeb and desktop
  | 'search_results_map' //  SlidingPreviewContainer <-- MWeb map view
  | 'similar_listings_module' // SimilarListingsContainer
  | 'similar_to_contacted_collection' // ListingCollection
  | 'similar_to_favorite_collection'; // ListingCollection

// https://dataportal.zillowgroup.net/event-registry/5601
export const emitTrackImpressionForPropertyCardEvent = ({
  listing,
  triggerLocation,
}: {
  listing: HotpadsListing;
  triggerLocation: PropertyCardTriggerLocation;
}) => {
  trackPropertyInfoCsEvent({
    envelope: getEnvelope({
      eventId: '5601',
      eventVersion: '1',
      templateId: '4',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'impression',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'property_card',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
    ...getPropertyInfo(listing),
  });
};
